import orderBy from 'lodash/orderBy';
import selectGameCards from './game-cards';

const selectSortedGameCards = (phrases, sortOrder, games) => orderBy(
  selectGameCards(
    phrases,
    [...games].sort(
      (a, b) => sortOrder.indexOf(a.name) - sortOrder.indexOf(b.name),
    ),
  ),
  'completed',
);
export default selectSortedGameCards;
